export const REQUEST_KEY = {
    GET_USER: 'getUser'
}